export default __webpack_public_path__ + "static/media/icr_preparando_pedido.9da048d5.svg";